import * as React from 'react';
import { useState , useEffect, useRef } from 'react';
import { StringHelpers } from '../helpers/StringHelpers';
import ReactHtmlParser from 'react-html-parser';

export interface PetitieTellerProps {
  formFieldDefinition: {
    name: string;
    label: string;
    text: string;
    maxPetitionCount: number;
    StartValuePetitionCount: number;

    explanation?: string;
  };
  initialValues: {
    [key: string]: string;
  };
}

function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (savedCallback) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function PetitieTeller(props: PetitieTellerProps) {
  let initial = 0;
  let maxCount = 50000;
  const maxPetitionCount = props.formFieldDefinition.maxPetitionCount || 0;
  let startCount = props.formFieldDefinition.StartValuePetitionCount || 0;

  if (props.initialValues && props.initialValues[props.formFieldDefinition.name] != null) {
    initial = startCount;
    const parsedInitialValue = parseFloat(props.initialValues[props.formFieldDefinition.name]);
    if(!isNaN(parsedInitialValue)) {
      initial += parsedInitialValue;
    }
    maxCount = Math.min(maxPetitionCount, (initial));
    initial = Math.max(initial - 10000, 0);
  }

  const [count, setCount] = useState(initial);
  const [delay, setDelay] = useState(20);

  useInterval(() => {
    const add = 257;
    if (count + add <= maxCount) {
      setCount(count + add);
      setDelay(delay + 1);
    } else {
      setCount(maxCount);
    }
  }, delay);

  const counterWidthPercentage = Math.min(100, count * 100 / props.formFieldDefinition.maxPetitionCount);

  return (
    <div className="form-group">
      <label className="petition-progress__label">{ReactHtmlParser(StringHelpers.replacePropertiesInString(props.formFieldDefinition.label, 
        {
          petitie: "<span class='petition-progress__counter'>" + count + "</span>",
          max: props.formFieldDefinition.maxPetitionCount
        }, 
        true))}</label>
      <p>{props.formFieldDefinition.explanation ? props.formFieldDefinition.explanation : props.formFieldDefinition.text}</p>
      <div className="petition-progress">
        <div style={{
          width: "calc( " + counterWidthPercentage + "% - 4px)"
        }} className="petition-progress__bar"></div>
      </div>
    </div>
  );
}